<template>
    <div class="w-full flex flex-1 surface-0 justify-content-center
        py-4 px-3 xl:p-6 lg:p-5 md:p-4
        flex-column xl:flex-row lg:flex-row md:flex-row
        align-items-center xl:align-items-start lg:align-items-start md:align-items-start
        xl:border-round-3xl lg:border-round-2xl md:border-round-xl
        text-center relative gap-5">

        <div class="w-full flex flex-column
            align-items-center xl:align-items-start lg:align-items-start md:align-items-start">
            <span v-if="!loading" class="flex flex-column gap-4 white-space-nowrap
                align-items-center xl:align-items-start lg:align-items-start md:align-items-start">
                <div v-if="!isTgApp && !isPWA" class="flex flex-row gap-2 text-500 text-md">
                    <span class="flex">{{ title }}</span>
                </div>
                <div class="flex flex-row align-items-center gap-2">
                    <span class="flex text-700 text-5xl font-medium">{{ get_format_amount(balance, null, 0) }} </span>
                    <Button v-if="!isTgApp && !isPWA"
                        @click="refresh" rounded icon="pi pi-sync" size="small" severity="secondary" class="ml-3"/>
                </div>
                <span class="flex text-500 text-sm font-medium uppercase">{{balance}} {{currency}}</span> 
            </span>
            <Skeleton height="2rem" v-else />
        </div>

        <div v-if="!loading" class="w-full align-items-center flex flex-row gap-3 max-w-30rem my-3
            justify-content-center xl:justify-content-end lg:justify-content-end md:justify-content-end">

            <div v-if="wallet_id && btnTopup" class="flex flex-column align-items-center justify-content-center mx-1">
                <Button @click="displayTopupPopup=true" rounded icon="pi pi-plus" size="large"
                    class="mb-2" severity="primary"/>
                <span class="text-xs text-500 font-medium">{{ content[lang].topupBtn }}</span>
            </div>

            <div v-if="walletsCount>1" class="flex flex-column align-items-center justify-content-center mx-1">
                <Button @click="displayPopupExchange=true" rounded icon="pi pi-arrow-right-arrow-left"  size="large"
                    class="mb-2 border-0" severity="primary" :disabled="false"/>
                <span class="text-xs text-500 font-medium">{{ content[lang].exchangeBtn }}</span>
            </div>
            <Message v-else-if="walletsCount===0" icon="pi pi-wallet" severity="info">
                <span class="text-sm">{{ content[lang].noAccounts }}</span>
            </Message>

            <div v-if="wallet_id && btnWithdraw && wallet_type=='deposit'" class="flex flex-column align-items-center justify-content-center mx-1">
                <Button @click="displayWithdrawPopup=true" rounded icon="pi pi-arrow-up" size="large"
                    class="mb-2 border-0" severity="primary" :disabled="false" />
                <span class="text-xs text-500 font-medium">{{ content[lang].withdrawBtn }}</span>
            </div>
        </div>
        <div v-if="loading" class="w-full align-items-center flex flex-row gap-5 max-w-30rem my-3
            justify-content-center xl:justify-content-end lg:justify-content-end md:justify-content-end">
            <Skeleton shape="circle" size="3rem"/>
            <Skeleton shape="circle" size="3rem"/>
            <Skeleton shape="circle" size="3rem"/>
        </div>
    </div>

    <!--Popup list-->
    <Dialog class="w-full border-round-2xl overflow-hidden border-none surface-100" modal 
        v-model:visible="displayTopupPopup" 
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: 'auto' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'border-noround-bottom' : 'max-w-30rem'">

        <template #header>
            <span class="text-lg font-medium">{{ content[lang].topupBtn }}</span>
        </template>

        <MobMenu :items=[]>
            <template v-slot:body>
                <div @click="displayTopupByTransfer=true;displayTopupPopup=false" v-if="wallet_id"
                    class="w-full flex flex-row px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:60px">
                    <div class="flex mr-3 align-items-center">
                        <Avatar class="text-600" size="small" icon="pi pi-credit-card" shape="circle"/>
                    </div>
                    <div class="flex flex-1 justify-content-left align-items-center">
                        <span class="text-600">{{ content[lang].topupBytransfer }}</span>
                    </div>
                    <div class="flex justify-content-right align-items-center">
                        
                    </div>
                </div>
                <div @click="displayPopupExchange=true;displayTopupPopup=false" v-if="wallet_id"
                    class="w-full flex flex-row px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:60px">
                    <div class="flex mr-3 align-items-center">
                        <Avatar class="text-600" size="small" icon="pi pi-arrow-right-arrow-left" shape="circle"/>
                    </div>
                    <div class="flex flex-1 justify-content-left align-items-center">
                        <span class="text-600">{{ content[lang].topupByInternal }}</span>
                    </div>
                    <div class="flex justify-content-right align-items-center">
                        
                    </div>
                </div>
                <div @click="displayPopupTopup=true;displayTopupPopup=false" v-if="deposit_wallet_id && (topupWalletTypes.includes(wallet_type))"
                    class="w-full flex flex-row px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:60px">
                    <div class="flex mr-3 align-items-center">
                        <Avatar class="text-600" size="small" icon="pi pi-bitcoin" shape="circle"/>
                    </div>
                    <div class="flex flex-1 justify-content-left align-items-center">
                        <span class="text-600">{{ content[lang].topupByCrypto }}</span>
                    </div>
                    <div class="flex justify-content-right align-items-center">
                        
                    </div>
                </div>
            </template>
        </MobMenu>
        <template #footer>
            <span class="text-lg font-medium mb-5"></span>
        </template>
    </Dialog>

    <!--Withdraw list-->
    <Dialog class="w-full border-round-2xl overflow-hidden border-none surface-100" modal 
        v-model:visible="displayWithdrawPopup" 
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: 'auto' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'border-noround-bottom' : 'max-w-30rem'">

        <template #header>
            <span class="text-lg font-medium">{{ content[lang].withdrawBtn }}</span>
        </template>

        <MobMenu :items=[]>
            <template v-slot:body>
                <div v-if="(isUserInGroup('admin') || isUserInGroup('tester')) && wallet_id && btnWithdraw && wallet_type=='deposit'" 
                    @click="displayWithdrawTransferPopup=true;displayWithdrawPopup=false"
                    class="w-full flex flex-row px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:60px">
                    <div class="flex mr-3 align-items-center">
                        <Avatar class="text-600" size="small" icon="pi pi-credit-card" shape="circle"/>
                    </div>
                    <div class="flex flex-1 justify-content-left align-items-center">
                        <span class="text-600">{{ content[lang].withdrawByTransfer }}</span>
                    </div>
                    <div class="flex justify-content-right align-items-center">
                        
                    </div>
                </div>
                <div @click="displayWithdrawCryptoPopup=true;displayWithdrawPopup=false" v-if="wallet_id && btnWithdraw && wallet_type=='deposit'"
                    class="w-full flex flex-row px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:60px">
                    <div class="flex mr-3 align-items-center">
                        <Avatar class="text-600" size="small" icon="pi pi-bitcoin" shape="circle"/>
                    </div>
                    <div class="flex flex-1 justify-content-left align-items-center">
                        <span class="text-600">{{ content[lang].withdrawByCrypto }}</span>
                    </div>
                    <div class="flex justify-content-right align-items-center">
                        
                    </div>
                </div>
            </template>
        </MobMenu>

        <template #footer>
            <span class="text-lg font-medium mb-5"></span>
        </template>
    </Dialog>


    <!--Popup by transfer-->
    <Dialog class="w-full border-none border-round-2xl" modal 
        v-model:visible="displayTopupByTransfer" 
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'max-w-30rem'">

        <template #header>
            <span class="text-lg font-medium">{{ content[lang].popupTopupTransfet }}</span>
        </template>
     
        <TopUpTransfer v-if="wallet_id" 
            :wallet_id="wallet_id" 
            :wallet_currency="currency"
            :onClick="sendClick" 
            @loading="doProcessing"/>
        
        <template #footer>
            <div class="field w-full">
                <Button @click="create()" :label="content[lang].popupTopupBtn" :loading="processing" :disabled="loading || processing || disabled"
                    class="p-button-lg w-full border-round-xl" icon="pi pi-plus" iconPos="right"/>
            </div>
        </template>
    </Dialog>

    <!--Popup Topup by crypto-->
    <Dialog class="w-full border-none surface-100 border-round-2xl" modal 
        v-model:visible="displayPopupTopup" 
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'max-w-30rem'">

        <template #header>
            <span class="text-lg font-medium">{{ content[lang].popupTopupCryptoTitle }}</span>
        </template>
     
        <TopupCrypto v-if="deposit_wallet_id" :wallet_id="deposit_wallet_id"/>
    </Dialog>

    <!--Popup exchange-->
    <Dialog class="w-full border-none border-round-2xl" modal 
        v-model:visible="displayPopupExchange" 
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'max-w-30rem'">

        <template #header>
            <span class="text-lg font-medium">{{ content[lang].popupExchangeTitle }}</span>
        </template>
     
        <ExchangeWallet :onClick="sendClick" @loading="doProcessing" @close="doCloseExchange"/>
        
        <template #footer>
            <div class="field w-full">
                <Button @click="create()" :label="content[lang].popupSwapBtn" :loading="processing" :disabled="loading || processing || disabled" 
                    class="p-button-lg w-full border-round-xl" icon="pi pi-arrow-right-arrow-left" iconPos="right"/>
            </div>
        </template>
    </Dialog>

    <!--Withdraw Crypto-->
    <Dialog class="w-full border-none border-round-2xl" modal v-if="btnWithdraw"
        v-model:visible="displayWithdrawCryptoPopup" 
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'max-w-30rem'">

        <template #header>
            <span class="text-lg font-medium">{{ content[lang].popupWithdrawCrypto }}</span>
        </template>
     
        <WithdrawCrypto v-if="deposit_wallet_id" :onClick="sendClick" :wallet_id="deposit_wallet_id" @loading="doProcessing" @disabled="doDisable" @close="doCloseWithdraw"/>
        
        <template #footer>
            <div v-if="deposit_wallet_id" class="field w-full">
                <Button @click="create()" :label="content[lang].popupWithdrawBtn" :loading="processing" :disabled="loading || processing || disabled"
                    class="p-button-lg w-full border-round-xl"
                    icon="pi pi-arrow-up" iconPos="right"/>
            </div>
        </template>
    </Dialog>

    <!--Withdraw by transfer-->
    <Dialog class="w-full border-none border-round-2xl" modal v-if="btnWithdraw"
        v-model:visible="displayWithdrawTransferPopup" 
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'max-w-30rem'">
        <template #header>
            <span class="text-lg font-medium">{{ content[lang].popupWithdrawCrypto }}</span>
        </template> 

        <WithdrawTransfer v-if="deposit_wallet_id" :onClick="sendClick" 
            :wallet_id="deposit_wallet_id" 
            @loading="doProcessing" @disabled="doDisable" @close="doCloseWithdraw"/>

        <template #footer>
            <div v-if="deposit_wallet_id" class="field w-full">
                <Button @click="create()" :label="content[lang].popupWithdrawBtn" :loading="processing" :disabled="loading || processing || disabled"
                    class="p-button-lg w-full border-round-xl"
                    icon="pi pi-arrow-up" iconPos="right"/>
            </div>
        </template>
    </Dialog>

</template>

<script>
import Connect          from '@/assets/js/Connect.js'
import Helper           from '@/assets/js/Helper.js'
import Accounts         from '@/components/personal/Accounts.vue'
import Transactions     from '@/components/personal/Transactions.vue'
import TopUpTransfer    from '@/components/widgets/send/TopUpTransfer.vue'
import TopupCrypto      from '@/components/widgets/send/TopupCrypto.vue'
import WithdrawCrypto   from '@/components/widgets/send/WithdrawCrypto.vue'
import WithdrawTransfer from '@/components/widgets/send/WithdrawTransfer.vue'
import ExchangeWallet   from '@/components/widgets/send/ExchangeWallet.vue'
import MobMenu          from '@/components/sides/menu/MobMenu.vue'

export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        balance: {
            type: Number,
            default: 0
        },
        currency: {
            type: String,
            default: ''
        },
        wallets: {
            type: Array,
            default: () => []
        },
        wallet_id: {
            type: String,
            default: ''
        },
        wallet_type: {
            type: String,
            default: ''
        },
        deposit_wallet_id: {
            type: String,
            default: ''
        },
        loading: {
            type: Boolean,
            default: false
        },
        btnTopup: {
            type: Boolean,
            default: true
        },
        btnWithdraw: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            header: {
                en: { title: 'Wallet' },
                ru: { title: 'Кошелек' }
            },
            content: {
                ru: { 
                    topupBtn: 'Пополнить',
                    withdrawBtn: 'Вывести',
                    exchangeBtn: 'Перевести',
                    accounts: 'Счета',
                    transactions: 'Транзакции',
                    transactionsBtn: 'Все транзакции',
                    popupTopupTransfet: 'Пополнение переводом',
                    popupTopupTitle: 'Пополнить переводом',
                    popupTopupCryptoTitle: 'Пополнить криптовалютой',
                    popupExchangeTitle: 'Перевести',
                    popupWithdrawCrypto: 'Вывести криптовалюту',
                    popupTopupBtn: 'Пополнить',
                    popupSwapBtn: 'Перевести',
                    popupWithdrawBtn: 'Вывести',
                    topupBytransfer: 'Пополнение переводом',
                    topupByInternal: 'С внутреннего счета',
                    topupByCrypto: 'Криптовалютой',
                    withdrawByCrypto: 'Криптовалютой',
                    withdrawByTransfer: 'Переводом на карту',
                    noAccounts: 'У вас еще нет счетов в кошельке',
                },
                en: { 
                    topupBtn: 'Top up',
                    withdrawBtn: 'Withdraw',
                    exchangeBtn: 'Swap',
                    accounts: 'Accounts',
                    transactions: 'Transactions',
                    transactionsBtn: 'All transactions',
                    popupTopupTransfet: 'Transfer from card',
                    popupTopupTitle: 'Top up from card',
                    popupTopupCryptoTitle: 'Top up with cryptocurrency',
                    popupExchangeTitle: 'Swap',
                    popupWithdrawCrypto: 'Withdraw cryptocurrency',
                    popupTopupBtn: 'Top up',
                    popupSwapBtn: 'Swap',
                    popupWithdrawBtn: 'Withdraw',
                    topupBytransfer: 'From card to card',
                    topupByInternal: 'From internal account',
                    topupByCrypto: 'With cryptocurrency',
                    withdrawByCrypto: 'Withdraw with cryptocurrency',
                    withdrawByTransfer: 'Withdraw by transfer',
                    noAccounts: 'You have no accounts in the wallet yet',
                },
                
            },
            wallet_is_blockchain: false,
            transactions: [],
            displayTopupPopup: false,
            displayWithdrawPopup: false,
            displayPopupTopup: false,
            displayTopupByTransfer: false,
            displayWithdrawCryptoPopup: false,
            displayWithdrawTransferPopup: false,
            displayPopupExchange: false,
            sendClick: false,
            processing: false,
            disabled: false,
            topupWalletTypes: ['deposit', 'vcard', 'merchant'],
        }
    },
    components: {
        Accounts,
        Transactions,
        TopUpTransfer,
        WithdrawTransfer,
        TopupCrypto,
        WithdrawCrypto,
        ExchangeWallet,
        MobMenu
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        screenSize() { return this.$store.getters.StateScreenSize },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
        walletsCount(){
            if (this.wallets && this.wallets.length > 0) {
                return this.wallets.length
            } else {
                return 0
            }
        }
    },
    methods: {
        isUserInGroup (type) { return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)},
        get_format_amount(value, currency, digits) {
            return this.helper.format_amount(value, currency, digits)
        },
        create(){
            this.sendClick = !this.sendClick
        },
        doProcessing(val){
            this.processing = val
        },
        doCloseExchange(){
            this.processing = false
            this.displayPopupExchange = false
        },
        doCloseWithdraw(){
            this.processing = false
            this.displayWithdrawCryptoPopup = false
        },
        doDisable(val){
            this.disabled = val
        },
        async refresh(){
            this.$emit('refresh', true)
        }
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
}   
</script>
